export function matchesEmployeeName(row, employeeName) {
  if (!employeeName?.trim()) return true;
  const q = employeeName.trim().toLowerCase();
  const userName = String(row?.userName ?? row?.UserName ?? '').toLowerCase();
  const firstName = String(row?.firstName ?? row?.FirstName ?? '').toLowerCase();
  const lastName = String(row?.lastName ?? row?.LastName ?? '').toLowerCase();
  const fullName = `${firstName} ${lastName}`.trim();

  return (
    userName.includes(q) ||
    fullName.includes(q) ||
    firstName.includes(q) ||
    lastName.includes(q)
  );
}

export function filterByEmployeeName(rows, employeeName) {
  if (!employeeName?.trim()) return rows || [];
  return (rows || []).filter((row) => matchesEmployeeName(row, employeeName));
}
